module.exports = __webpack_public_path__ + "img/brands-casa-barilla-logo.png?d61d9626b0922a0293d7f5da20558429";